import React, { useContext, useEffect, useRef, useState } from 'react';
import { 
    Box,
    Button,
    CircularProgress,
    ClickAwayListener,
    Fade,
    Popper,
    Typography
} from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import ClearIcon from '@mui/icons-material/Clear';
import { useAuth0 } from "@auth0/auth0-react";
import ProjectContext from '../../contexts/ProjectContext';
import ItemList from '../menuitem/ItemList';
import SecondaryButton from '../buttons/SecondaryButton';
import customTheme from '../../theme';
import {useFetch} from '../../components/auth/useFetch';

export default function UploadEdlDialog(props) {

    const { anchorEl, clickAway, open, updateParentList } = props
    const projectContext = useContext(ProjectContext);
    const [fileList, setFileList] = useState([])
    const [isUploading, setIsUploading] = useState(false)
    const fetchWithAuth = useFetch()

    const dragEnter = (e) => {
        e.preventDefault()
    }
    const dragOver = (e) => {
        e.preventDefault()
    }
    const dragLeave = (e) => {
        e.preventDefault()
    }
    const fileDrop = (e) => {
        e.preventDefault()
        const droppedFiles = Array.from(e.dataTransfer.files).map((file) => ({'name': file.name, 'file': file}))
        setFileList((prev) => {
            const filteredFiles = droppedFiles.filter((file) => {
                return !prev.some((prevFile) =>
                    prevFile.name === file.name
                );
            });
            return [...prev, ...filteredFiles];
        })
    }

    const uploadFile = async (file) => {
        const formData = new FormData();
        formData.append("file_upload", file.file);
        var requestOptions = {
            method: 'POST',
            body: formData,
            headers: {
                'X-Project-ID': projectContext?.project_db
            },
        }
        const url = `${process.env.REACT_APP_BACKEND_URL}/konsol/edlclipnames/`
        try
        {
            const response = await fetchWithAuth(url, requestOptions)
            if(response.ok){
                return true
            }
            else{
                return false
            }
        }
        catch(e){
            console.error(e);
            return false
        }
    }
   
    const uploadFiles = async () => {
        setIsUploading(true)
        const results = await Promise.all(fileList.map(uploadFile))
        setIsUploading(false)
        const uploadedFileList = [...fileList.filter((_, index) => results[index])] 
        const failedFileList = [...fileList.filter((_, index) => !results[index])]

        updateParentList((prev) => {
            return [...prev, ...uploadedFileList.map((file, index) => {
               const { name, ...fileProp } = file 
                return name
            })]
        })
        setFileList((prev) => {
            return [...failedFileList]
        })
    }

    const clearFile = (index) => {
        setFileList((prev) => {
            prev.splice(index, 1)
            return [...prev]
        })
    }

    const clearAllFiles = () => {
        setFileList([])
    }

    return (
        <Popper
            id={open ? 'upload-popper' : undefined}
            open={open}
            anchorEl={anchorEl}
            transition
            disablePortal
            style={{ zIndex: 100 }}
            modifiers={[
                {
                    name: 'flip',
                    enabled: true,
                    options: {
                        altBoundary: false,
                        rootBoundary: 'document',
                        padding: 8,
                    },
                },
                {
                    name: 'preventOverflow',
                    enabled: false,
                    options: {
                        altAxis: false,
                        altBoundary: false,
                        tether: false,
                        rootBoundary: 'document',
                        padding: 8,
                    },
                },
            ]}
        >
        {({ TransitionProps }) => (
            // <ClickAwayListener onClickAway={clickAway}>
                <Fade {...TransitionProps}>
                    <Box
                        width={'720px'}
                        height={'584px'}
                        display="flex"
                        flexDirection="column"
                        backgroundColor={'rgba(0,0,0,0.9)'}
                        sx={{
                            border: '2px solid rgba(107, 164, 125, 0.3)',
                            borderRadius: '8px'
                        }}
                    >
                        <Box
                            onDragEnter={dragEnter}
                            onDragOver={dragOver}
                            onDragLeave={dragLeave}
                            onDrop={fileDrop}
                            width={'100%'}
                            height={'100%'}
                            overflow={'auto'}
                            display="flex"
                            flexDirection="column"
                            borderTop='2px solid rgba(107, 164, 125, 0.3)'
                        >
                            {fileList.length > 0 
                            ?
                                fileList.map((file, index) => (
                                    <ItemList
                                        key={index}
                                        title={file.name}
                                        iconButton={
                                            isUploading 
                                            ?
                                            <SecondaryButton
                                                icon={<CircularProgress 
                                                    sx = {{ 
                                                        color: (theme) => customTheme.palette.secondary.main,
                                                    }}
                                                    thickness={5}
                                                />}
                                            />
                                            :
                                            <SecondaryButton
                                                onClick={() => clearFile(index)}
                                                hoverColor='red'
                                                icon={<ClearIcon />
                                            }
                                            />
                                        }
                                    />
                                ))
                            :
                            <Box
                                width={'100%'}
                                height={'100%'}
                                display="flex"
                                flexDirection="column"
                                justifyContent="center"
                                alignItems="center"
                            >
                                <CloudUploadIcon style={{fill: "rgba(128,128,128,0.4)"}} sx={{ fontSize: 100 }} />
                                <Typography color={'rgba(128,128,128,1)'} component="span" variant="h7" align="left" gutterBottom>
                                    Drag and Drop files here
                                </Typography>
                            </Box>
                            }
                            <Box
                                display={'flex'}
                                justifyContent={'space-between'}
                                marginTop={'auto'}
                            >
                                <Button variant='contained' onClick={clearAllFiles}>CLEAR ALL</Button>
                                <Button variant='contained' onClick={uploadFiles}>UPLOAD</Button>
                            </Box>
                        </Box>
                    </Box>
                </Fade>
            // </ClickAwayListener>
        )}
        </Popper>
    )}